import { BFormGroup } from './form-group';
import { pluginFactory } from '../../utils/plugins';
var FormGroupPlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BFormGroup: BFormGroup,
    BFormFieldset: BFormGroup
  }
});
export { FormGroupPlugin, BFormGroup };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/components/form-group/index.js
// module id = ./node_modules/bootstrap-vue/esm/components/form-group/index.js
// module chunks = 1